
export const isBrowser = (): boolean =>
  typeof window !== "undefined" || (process as any).browser;

export const isEdgeRuntime = (): boolean => {
  // const env = process.env;
  return process.env?.NEXT_RUNTIME === "edge" || process.env?.NEXT_RUNTIME === "experimental-edge";
};

export const isDevEnvironment = (): boolean => {
  // const env = process.env;
  if (!isBrowser()) {
    return process.env.VERCEL_ENV === "development";
  }
  return process.env.NEXT_PUBLIC_ENV === "development";
};

export const isPreviewEnvironment = (): boolean => {
  // const env = process.env;
  if (!isBrowser()) {
    return process.env.VERCEL_ENV === "preview";
  }
  return process.env.NEXT_PUBLIC_ENV === "preview";
};

export const isProdEnvironment = (): boolean => {
  // const env = process.env;
  if (!isBrowser()) {
    return process.env.VERCEL_ENV === "production";
  }
  return process.env.NEXT_PUBLIC_ENV === "production";
};

export const isNextJSServer = (): boolean => {
  // const env = process.env;
  return !isBrowser() && !!process.env.STRIPE_SECRET_KEY;
};

export const isBrowserExtension = (): boolean => {
  // const env = process.env;
  return process.env.PROJECT_TYPE === "browser-extension";
};

export const isVercelBuild = (): boolean => {
  // const env = process.env;
  return process.env.VERCEL === "1" && !process.env.VERCEL_URL;
};

